/** Who a thread bubble is attributed to. */
export type ChatRole = "user" | "bot" | "agent" | "system";

/**
 * Backend `messages.sender` vocabulary → the role the thread renders.
 *
 * The column is written from thirteen call sites in app.py and
 * mri_analysis.py, and `/api/chat/messages/active` passes the raw value
 * through. Anything not listed here is a staff username — app.py:1501 stores
 * `session["username"]` when an operator replies — so the fallback is the
 * operator.
 *
 * The patient's own messages are stored as "patient", never "user". Reading
 * it as "user" is what made a refreshed thread attribute a patient's own
 * words to hospital staff, which is the mistake this map exists to prevent.
 */
const ROLES: Record<string, ChatRole> = {
  patient: "user",
  user: "user",
  bot: "bot",
  system: "system",
};

export function senderRole(sender: string): ChatRole {
  return ROLES[sender.trim().toLowerCase()] ?? "agent";
}
